<template>
  <div>
    <app-header></app-header>
    <app-banner></app-banner>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "../components/common/AppHeader";
import AppBanner from "../components/common/AppBanner";
import AppFooter from "../components/common/AppFooter";
export default {
  components: {
    AppHeader,
    AppFooter,
    AppBanner,
  },
};
</script>

<style lang="less" scoped>
</style>